var React = require('react');

function Quick (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"24,25 4,25 4,5 17,5 17,7 6,7 6,23 22,23 22,9 24,9 \t","key":0}),React.createElement("polygon",{"points":"13.5,19.8 7.9,12.6 9.4,11.4 13.3,16.4 22.1,1.9 23.9,3 \t","key":1})])]);
}

Quick.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = Quick;

Quick.default = Quick;
